import i18n from "i18next";
import enUsTrans from "./locales/en.json";
import zhCnTrans from "./locales/zh.json";
import { initReactI18next } from "react-i18next";
i18n.use(initReactI18next)
  .init({
    resources: {
      en: { translation: enUsTrans },
      zh: { translation: zhCnTrans }
    },
    // lng:process.env.LANGUAGE,
    lng: "en",
    fallbackLng: "zh",
    debug: false,
    interpolation: { escapeValue: false }
  });
window.i18n = i18n;
export default i18n;